import { render } from "./Contact.vue?vue&type=template&id=5d6eb470&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=5d6eb470&scoped=true&lang=sass"
script.render = render
script.__scopeId = "data-v-5d6eb470"

export default script